<template>
  <div>
    <div class="uk-card uk-card-default uk-card-body uk-card-small">
      <img :src="product.productData.proofImage" />
      <div class="uk-margin-small">
        <select v-model="product.productData.productType" class="uk-select">
          <option v-for="product in allProducts" :key="product.productType">{{
            product.productType
          }}</option>
        </select>
      </div>
      <div
        v-for="alert in settings.alertsCollection.items"
        :key="alert.keyword"
        class="uk-margin-small"
      >
        <label v-if="alert.keyword == 'hidden'">
          <input
            v-model="product.productData.hidden"
            class="uk-checkbox"
            type="checkbox"
          />
          {{ alert.alertName }}
        </label>
        <label v-else>
          <input
            v-model="product.productData.alerts[alert.keyword]"
            class="uk-checkbox"
            type="checkbox"
          />
          {{ alert.alertName }}
        </label>
      </div>
      <div class="uk-margin-small">
        <textarea
          v-model="product.productData.customNotes"
          class="uk-textarea"
          rows="2"
          placeholder="Custom notes"
        ></textarea>
      </div>
      <p class="uk-margin-small uk-text-break">
        ID: {{ product.productData.proofID }}
      </p>
      <p class="uk-margin-small uk-text-break">
        {{ product.productData.fileName }}
      </p>
      <p class="uk-margin-small">
        {{ product.productData.created.seconds | moment("MM/DD/YYYY") }}
      </p>
      <button
        class="uk-button uk-button-danger uk-width-1-1 uk-margin-small-top"
        @click="deleteProduct"
      >
        Delete
      </button>
    </div>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  name: "ProductAdmin",
  components: {},
  filters: {
    capitalize: function(value) {
      if (!value) return "";

      return _.startCase(value);
    }
  },
  props: {
    product: { type: Object, default: null },
    settings: { type: Object, default: null },
    allProducts: { type: Array, default: null }
  },
  watch: {},
  mounted: function() {},
  methods: {
    deleteProduct() {
      var self = this;
      self.$emit("delete-product", self.product.productId);
    }
  }
};
</script>

<style type="text/css">
.pointer {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/AdminProduct.vue